<template>
  <div
    v-if="hasCellList"
    class="multi-banner-container"
    id="text-banner-swiper"
    ref="textBannerContainer"
    :key="`multi_section_index_${multisectionIndex}`"
  >
    <swiper
      :options="swiperOption"
      ref="textBanner"
      @click.native="goDetail()"
    >
      <swiper-slide
        v-for="(cell, index) in cellList"
        :key="`${index}__${catalogId}__swiper__slide`"
      >
        <BannerTextItem :bannerInfo="cell" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination" />
    </swiper>
  </div>
</template>
<script>
import { convertBand } from '@/common/converter/convert-band'
import { AnalizeService } from '@/common/api/api.service'
import BannerTextItem from '@/components/section/template/banner/BannerTextItem'
import { getEventListByType } from '@/common/util/event.util'
import { bannerLink } from '@/common/util/common'

export default {
  // legacy swiper 라이브러리로 인해 추후 vue 3 문법으로 변경 예정
  name: 'BigBannerCatalog',
  props: {
    sectionInfo: {
      type: Object,
      default: () => {}
    },
    catalogInfo: {
      type: Object,
      default: () => {}
    },
    multisectionIndex: {
      type: Number,
      default: 0
    }
  },
  components: {
    BannerTextItem
  },
  data () {
    return {
      band: {},
      cellList: [],
      genTime: '',
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 8,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        loop: true,
        centeredSlides: true,
        autoplay: {
          running: true,
          timeout: 3500,
          disableOnInteraction: false
        },
        speed: 700,
      }
    }
  },
  computed: {
    hasCellList () {
      return this.cellList.length > 0
    },
    catalogId () {
      return this.catalogInfo?.id ?? ''
    }
  },
  methods: {
    goDetail () {
      const bannerIndex = this.$refs.textBanner.swiper.clickedSlide.dataset.swiperSlideIndex
      const { onNavigationEvent, onClickEvent } = getEventListByType(this.cellList[bannerIndex].event_list)
      if (onClickEvent) {
        AnalizeService.sendLogList([onClickEvent]).then(() => {
          bannerLink(onNavigationEvent.url)
        })
      } else {
        bannerLink(onNavigationEvent.url)
      }
    },
    async setData () {
      try {
        this.band = await convertBand(this.catalogInfo)
        this.cellList = this.band?.band?.celllist ?? []
      } catch (error) {
        console.error(error)
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.resize)
  },
  created () {
    this.setData()
  }
}
</script>
